// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// proscs, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import NavigationArrowRight from "@sc/XDL/Icons/NavigationArrowRight";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { xBaseTheme } from "@sc/XDL/types";
import { color } from "@sc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        bodyColor: "common.ui1",
        childTypographyProps: {
            size: 14,
            lineHeight: "22px",
            weight: fontConfig.weight.regular,
            color: "text",
        },
        panelRowProps: {
            color: "common.ui1",
            moreIconProps: {
                src: NavigationArrowRight,
                size: 10,
                color: "primary.main",
                css: css`
                    &${IconWrapper} {
                        flex-grow: 1;
                        justify-content: flex-end;
                        color: ${color("text.link")};
                        height: 22px;
                        width: 7px;
                    }
                `,
            },
        },
        backIconProps: {
            color: "primary.main",
            src: ArrowLeft,
            size: 14,
        },
        panelChildrenSeparator: {
            css: css`
                height: 1px;
                border-top: 1px solid ${color("common.border")};
                margin: 0 auto 8px auto;
                width: calc(100% - 32px);
            `,
        },
    },
} as xBaseTheme["panelMenu"];
